// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Modal_modalContainer__28A7L","modalBox":"Modal_modalBox__3YltP"};